import React, { Component } from 'react';

const TableHead = () => (
    <thead class="thead-light">
        <tr>
            <th scope="col">Nome</th>
            <th scope="col">Email</th>
            <th scope="col">Telefone</th>
            <th scope="col">Função</th>
            <th scope="col">Data Cadastro</th>
            <th scope="col">Último Acesso</th>
            <th scope="col">Status</th>
            <th scope="col"></th>
        </tr>
    </thead>
);

export default TableHead;


// WEBPACK FOOTER //
// ./src/components/Pages/Users/TableHead.js